import { render, staticRenderFns } from "./CategoryNavSlider.vue?vue&type=template&id=1fd9bff8"
import script from "./CategoryNavSlider.vue?vue&type=script&lang=js"
export * from "./CategoryNavSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoryNavSlider.vue?vue&type=style&index=0&id=1fd9bff8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports